/**
 * Survey Constants
 * Centralized constants for survey module
 */

export const SURVEY_STATUS = {
  ACTIVE: 'A',
  PAUSED: 'P',
  DELETED: 'D',
}

export const SURVEY_STATUS_LABELS = {
  [SURVEY_STATUS.ACTIVE]: 'active',
  [SURVEY_STATUS.PAUSED]: 'paused',
  [SURVEY_STATUS.DELETED]: 'deleted',
}

export const SURVEY_DIALOG_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
}

export const SURVEY_ERROR_MESSAGES = {
  FETCH_FAILED: 'Failed to fetch survey data',
  SAVE_FAILED: 'Failed to save survey',
  DELETE_FAILED: 'Failed to delete survey',
  CLONE_FAILED: 'Failed to clone survey',
  STATUS_CHANGE_FAILED: 'Failed to change survey status',
}

export const SURVEY_DEFAULT_VALUES = {
  ROWS_PER_PAGE: 10,
  INITIAL_PAGE: 0,
  INITIAL_SORT: 'updateTimestamp',
  INITIAL_SORT_ORDER: 'DESC',
}

export const DRAFT_MESSAGES = {
  TITLE: 'You have a unsaved draft',
  IGNORE: 'ignore',
  VIEW: 'view',
}

/**
 * Default language object for multi-language inputs
 */
export const DEFAULT_LANGUAGES = {
  EN: '',
  ZH_CN: '',
  ZH_HK: '',
}

/**
 * Survey list table columns configuration
 */
export const SURVEY_LIST_COLUMNS = [
  {
    field: 'id',
    headerName: 'ID',
    width: 200,
    flex: 1,
  },
  {
    field: 'title',
    headerName: 'Title',
    width: 200,
    flex: 1,
  },
  {
    field: 'remarks',
    headerName: 'Remarks',
    width: 150,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 50,
  },
]
